<template>
  <div class="nav-intimo">
    <p>
      {{ profile.documentType }}: <span>{{ profile.dniUser }} </span>
    </p>
    <p>
      Nombre: <span>{{ profile.firstName }} {{ profile.lastName }}</span>
    </p>
    <p>
      Email: <span>{{ profile.email }} </span>
    </p>
    <p>
      Fecha Suscripción: <span>{{ suscriptionDate }} </span>
    </p>
    <div class="profile"><span>Usuario intimo</span></div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props: ['profile'],
  computed: {
    suscriptionDate() {
      return moment(this.profile.creationDate).format('DD/MM/YYYY');
    }
  }
};
</script>
<style lang="scss">
.nav-intimo {
  margin-bottom: 1rem;
  p {
    margin-bottom: 0.3rem;
    font-weight: bold;
    span {
      font-weight: 300;
    }
  }
  .profile {
    color: #fff;
    background: #000d1e;
    padding: 0.3rem 1rem;
    max-width: 200px;
    display: flex;
    justify-content: center;
  }
}
</style>